import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../../../ingredients/services";
import { DishServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { StaticsServices } from '../../../../services/statics';
import { DishCreateNutritionPage } from '../../dish-create-nutrition/dish-create-nutrition';
import { NotificationsServices } from '../../../../services/notificationsServices';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishIngredientsQuantityPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-ingredients-quantity',
  templateUrl: 'dish-ingredients-quantity.html',
})

export class DishIngredientsQuantityPage {


  update_state: boolean = false;
  dish_uid: string;
  foodcost_parts: number = 1;
  foodcost_static: number = 0;
  total: number = 0;
  total_ration: number = 0;
  dish_name: string;
  dish: any;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public dishServices: DishServices,
    public globals: Globals,
    public staticsServices: StaticsServices,
    private notificationsServices: NotificationsServices,
    public translate: TranslateService) {

    this.dish_uid = this.navParams.get('dish_uid');
    this.update_state = this.navParams.get('update');
    this.dish_name = this.navParams.get('dish_name');
    this.dish = this.navParams.get('dish');
    if (this.update_state) {
      this.foodcost_parts = this.navParams.get('foodcost_parts');
      this.foodcost_static = this.navParams.get('foodcost_static');
    } else {
      this.foodcost_parts = 1;
      this.foodcost_static = 0;
    }

    this.calculateInitial();
  }

  calculateRow(index) {
    var quantity = this.ingredientsServices.foodcost_array_tmp[index][5];
    var waste = this.ingredientsServices.foodcost_array_tmp[index][6];
    var price = this.ingredientsServices.foodcost_array_tmp[index][3];

    //Calculo de la merma
    this.ingredientsServices.foodcost_array_tmp[index][8] = this.ingredientsServices.calculateWaste(waste, quantity);
    //Calculo precio
    this.ingredientsServices.foodcost_array_tmp[index][9] = this.ingredientsServices.calculatePrice(price, this.ingredientsServices.foodcost_array_tmp[index][8], this.ingredientsServices.foodcost_array_tmp[index][4]);
    this.calculateTotal();
  }

  calculateTotal() {
    var _total = 0;
    for (var i = 0; this.ingredientsServices.foodcost_array_tmp.length > i; i++) {
      _total += this.ingredientsServices.foodcost_array_tmp[i][9];
    }
    this.total = _total;
    this.total_ration = this.total / this.foodcost_parts;
  }

  calculateInitial() {
    for (var i = 0; this.ingredientsServices.foodcost_array_tmp.length > i; i++) {
      this.calculateRow(i);
    }
  }

  delete(index) {
    this.ingredientsServices.foodcost_array_tmp.splice(index, 1);
    this.calculateInitial();
  }


  async update() {
    var _array = Array();
    var _allergens = Array();

    var _dish = await this.dishServices.getDish(this.dish_uid);



    _allergens = _dish.allergens;
    if (_allergens == undefined) {
      _allergens = [];
    }

    for (var i = 0; this.ingredientsServices.foodcost_array_tmp.length > i; i++) {

      //dataset plat_ingr
      this.globals.dataSet('plat_ingr', this.ingredientsServices.foodcost_array_tmp[i][1], '', this.dish_name);

      _array.push({
        quantity: this.ingredientsServices.foodcost_array_tmp[i][5],
        uid: this.ingredientsServices.foodcost_array_tmp[i][0],
        pricetotal_static: this.ingredientsServices.foodcost_array_tmp[i][9],
        quantity_gross: this.ingredientsServices.foodcost_array_tmp[i][8],
        waste: this.ingredientsServices.foodcost_array_tmp[i][6],
        provider_static: this.ingredientsServices.foodcost_array_tmp[i][7],
        name_static: this.ingredientsServices.foodcost_array_tmp[i][1],
        measurement_static: this.ingredientsServices.foodcost_array_tmp[i][4],
        price_static: this.ingredientsServices.foodcost_array_tmp[i][3],
        updated_at: new Date(),
        type: this.ingredientsServices.foodcost_array_tmp[i][10],
      });

      for (var j = 0; this.ingredientsServices.foodcost_array_tmp[i][2].length > j; j++) {
        _allergens.push(
          this.ingredientsServices.foodcost_array_tmp[i][2][j],
        );
      }

    }


    var _uniqueAllergens = [];
    $.each(_allergens, function (i, el) {
      if ($.inArray(el, _uniqueAllergens) === -1) _uniqueAllergens.push(el);
    });

    if (_array.length > 0) { //Controlamos que en array tenga como minimo algun elemento.
      this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
        'foodcost': _array,
        'foodcost_parts': this.foodcost_parts,
        'foodcost_static': this.total,
        'allergens': _uniqueAllergens,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(async () => {
        //comprobamos que el precio tenga veneficios de un 66%
        var foodcost = this.total / this.foodcost_parts;
        var price = this.globals.createSubTotal(_dish.price, this.globals.RESTAURANT_TAX);
        //notificamos que el plato x tiene un foodcost con poco beneficio
        if ((100 - this.globals.regla3(price, foodcost)) <= 33) {
          var _notification = {
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'title': this.translate.instant("notification-push-plato-poco-beneficio-title"),
            'description': this.translate.instant("notification-push-plato-poco-beneficio-desc-1") + this.dish_name + this.translate.instant("notification-push-plato-poco-beneficio-desc-2"),
          }
          this.notificationsServices.notificationPushAllRestaurant(_notification);
        }
        //
        if (this.update_state) {
          this.globals.GAtrackView('Dish', 'Dish - Escandallo', this.globals.restaurant.email, 'Create/Update', 'Update foodcost select quantity', 'Dish', this.dish_name);
          this.staticsServices.changeStateStaticWait(true);
          this.navCtrl.remove(this.navCtrl.getPrevious().index);
          this.navCtrl.pop();
        } else {
          this.globals.GAtrackView('Dish', 'Dish - Escandallo', this.globals.restaurant.email, 'Create/Update', 'Create foodcost select quantity', 'Dish', this.dish_name);
          //dataset
          this.globals.dataSet('plat_cost', this.total_ration, '', this.dish_name, '');
          //
          this.navCtrl.push(DishCreateNutritionPage, {
            update: this.update_state,
            dish_uid: this.dish_uid,
            dish_name: this.dish_name
          })
        }
      });
    } else {
      this.navCtrl.push(DishCreateNutritionPage, {
        update: this.update_state,
        dish_uid: this.dish_uid,
        dish_name: this.dish_name
      })
    }
  }

  //Precio total ticket sin impuestos
  totalOrderSelectedNoTax(total, tax) {
    var sub = total / ((tax + 100) / 100);
    return sub;
  }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-cost/dish-ingredients-quantity/dish-ingredients-quantity.ts